import React from "react";
import { Media } from "reactstrap"
import UnitView from "../../components/units/UnitView";
import _ from "lodash";
import * as Helper from "../../utils/Helper";

class CollapseUnitView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            collapsed: true,
            showToggleBtn: false,
            unitViewHeight: null
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (!_.isEqual(this.props.unit, nextProps.unit)) {
            return true;
        }
        if (this.props.collapsedHeight !== nextProps.collapsedHeight) {
            return true;
        }
        if (this.props.width !== nextProps.width) {
            return true;
        }
        if (this.props.height !== nextProps.height) {
            return true;
        }
        if (this.props.containerStyle !== nextProps.containerStyle) {
            return true;
        }
        if (this.props.contentStyle !== nextProps.contentStyle) {
            return true;
        }
        if (this.state.unitViewHeight !== nextState.unitViewHeight) {
            return true;
        }
        if (this.state.collapsed !== nextState.collapsed) {
            return true;
        }
        if (this.state.showToggleBtn !== nextState.showToggleBtn) {
            return true;
        }
        return false;
    }

    toggle = () => {
        this.setState({ collapsed: !this.state.collapsed })
    }

    render() {
        const { viewMode, containerStyle, contentStyle = {}, width, height, collapsedHeight, unit } = this.props;

        const { collapsed, showToggleBtn } = this.state;

        return (
            <div style={containerStyle}>
                <Media style={collapsed ? { height: collapsedHeight, overflow: "hidden" } : {}}>  
                    {unit.cover ? 
                    <img src={Helper.convertToFileServerPath(unit.cover)} style={{ borderBottomLeftRadius: 10, borderBottomRightRadius: 10, width: "100%" }} onLoad={({ target }) => {
                        if (target.height > collapsedHeight) {
                            this.setState({ collapsed: true, showToggleBtn: true })
                        } else {
                            this.setState({ collapsed: false })
                        }
                    }} /> :                 
                     <div style={{ borderBottomLeftRadius: 10, borderBottomRightRadius: 10, width: "100%", height: height, ...contentStyle, overflowY: (collapsed ? 'hidden' : 'auto') }}>
                       <UnitView unitType={unit.unitType} cover={unit.cover} data={unit.data} width={width - 4} height={undefined} viewMode={viewMode}
                            onUnitMounted={(unitView) => {
                                if (unitView) {
                                    if (height != this.state.unitViewHeight) {
                                        const state = height > collapsedHeight ? 
                                            { collapsed: true, showToggleBtn: true } : { collapsed: false };  
                                        this.setState({ unitViewHeight: height, ...state });
                                    }                                                                                                         
                                }
                            }}/>
                    </div>}
                </Media>
                {showToggleBtn && (
                    <div style={{ marginTop: 10, width: "100%", backgroundColor: "#DCDCDC", textAlign: "center", borderBottomLeftRadius: 10, borderBottomRightRadius: 10 }}
                        onClick={(e) => {
                            this.toggle();
                            e.stopPropagation();
                        }}>
                        {collapsed ?
                            <i className="ni ni-bold-down" style={{ fontSize: 25 }} />
                            :
                            <i className="ni ni-bold-up" style={{ fontSize: 25 }} />
                        }
                    </div>
                )}
            </div>
        );
    }
}

export default CollapseUnitView;
